import axios, { InternalAxiosRequestConfig } from 'axios';

const setBearer = (config: InternalAxiosRequestConfig) => {
  const accessToken = localStorage.getItem('@accessToken');
  if (accessToken) {
    const newConfig = config;
    newConfig.headers.Authorization = `Bearer ${accessToken}`;
    return newConfig;
  }

  return config;
};

export const customAxios = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URL}/`,
  timeout: 1000 * 60,
  params: {},
});

customAxios.defaults.headers['Access-Control-Allow-Origin'] = '*';

customAxios.interceptors.request.use((config) => setBearer(config));
customAxios.interceptors.response.use((res) => {
  if (process.env.REACT_APP_CLIENT_ENVIRONMENT !== 'prod') {
    const removeHttpProtocol = (url: string) => url.replace(/(^\w+:|^)\/\//, '');
    console.log(`\x1b[31m${removeHttpProtocol(res.request.responseURL)}`, {
      response: res.data,
    });
  }

  if (!res.data) return res;
  return res.data;
});
